// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1CiJ9","content":"RecentSearches_content__1fVcN"};